import "../components/elements/slider/slider.js";

import Accordion from "../components/elements/accordion/accordion.js";
import Dialog from "../components/elements/dialog/dialog.js";
import Footer from "../components/template-components/footer/footer.js";
import FormValidation from "../components/elements/form/form-validation/form-validation.js";
import Header from "../components/template-components/header/header.js";
import SideNav from "../components/template-components/side-nav/side-nav.js";

const Factory = {
	".js-Accordion": Accordion,
	".js-Dialog": Dialog,
	".js-Footer": Footer,
	".js-Form": FormValidation,
	".js-Header": Header,
	".js-SideNav": SideNav,
};

Object.keys(Factory).forEach((key) => {
	Array.from(document.querySelectorAll(key)).map(
		(element) => new Factory[key](element),
	);
});
